var _rect, _rect2, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtGedolim = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 72,
    height: 84,
    rx: 3,
    stroke: "#D28A60",
    strokeWidth: 2.5,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13,
    width: 62,
    height: 74,
    rx: 2,
    stroke: "#D28A60",
    strokeWidth: 1.2,
    fill: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 42,
    rx: 14,
    ry: 17,
    stroke: "#D28A60",
    strokeWidth: 2.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 38,55 Q 50,62 62,55",
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 22,84 Q 30,66 50,62 Q 70,66 78,84",
    stroke: "#D28A60",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtGedolim);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-gedolim.209c7735963c3af3a31b09123b70db5b.svg";